module.exports = __webpack_public_path__ + "static/media/Barmag Spindle -.61998560.jpg";